export interface OrgGroup {
  name: string;
  database: string;
  warehouse: string;
  role: string;
  id: string;
  databaseCreated: boolean;
}

export enum AdvancedAnalyticsStatus {
  NOT_REQUESTED = 'NOT_REQUESTED',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  WAITING_DEMO = 'WAITING_DEMO',
  WAITING_SETUP = 'WAITING_SETUP',
  DW_NOT_CREATED = 'DW_NOT_CREATED',
  DW_CREATED = 'DW_CREATED',
  CANCELLED_REQUEST = 'CANCELLED_REQUEST',
  NO_ACCESS = 'NO_ACCESS',
}
